import { lazy } from 'react';

// Collapse
export const JmeCollapse = lazy(() => import('./JmeCollapse'));

export const JmeAccordionGroup = lazy(() => import('./JmeAccordionGroup'));
export const JmeAccordionItem = lazy(() => import('./JmeAccordionItem'));

export const JmeShowAllCollapse = lazy(() => import('./JmeShowAllCollapse'));
